// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DirectoryObject_item__ppRg1 {
  background-color: var(--white);
  display: flex;
  justify-content: space-between;
  padding: 6px 4px;
  border-bottom: 1px solid #E0E7EB;
  cursor: pointer;
  width: 100%;
}
@media (min-width: 640px) {
  .DirectoryObject_item__ppRg1 {
    padding-right: 28px;
  }
}
@media (hover: hover) {
  .DirectoryObject_item__ppRg1:hover {
    background-color: var(--accent-color);
  }
  .DirectoryObject_item__ppRg1:hover .DirectoryObject_name__aMAMd,
  .DirectoryObject_item__ppRg1:hover .DirectoryObject_path__MQkl0 {
    color: var(--white);
  }
}

.DirectoryObject_content__noSOB {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding-right: 10px;
  gap: 3px;
}

.DirectoryObject_name__aMAMd {
  font-family: Euclid Circular B;
  font-weight: 400;
  font-size: 14px;
  line-height: 124%;
  letter-spacing: 0%;
  color: #151B26;
}

.DirectoryObject_path__MQkl0 {
  font-family: Euclid Circular B;
  font-weight: 400;
  font-size: 12px;
  line-height: 114%;
  letter-spacing: 0%;
  color: #7A808B;
}

.DirectoryObject_highlight__8f7VP {
  background-color: #FED45A;
  color: #151B26;
}`, "",{"version":3,"sources":["webpack://./src/components/DirectoryObject/DirectoryObject.module.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;AACF;AACE;EATF;IAUI,mBAAA;EAEF;AACF;AAAE;EACE;IACE,qCAAA;EAEJ;EAAI;;IAEE,mBAAA;EAEN;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;EACE,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAAF;;AAGA;EACE,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,cAAA;AAAF","sourcesContent":[".item {\n  background-color: var(--white);\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 4px;\n  border-bottom: 1px solid #E0E7EB;\n  cursor: pointer;\n  width: 100%;\n\n  @media (min-width: 640px) {\n    padding-right: 28px;\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      background-color: var(--accent-color);\n\n      .name,\n      .path {\n        color: var(--white);\n      }\n    }\n  }\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding-right: 10px;\n  gap: 3px;\n}\n\n.name {\n  font-family: Euclid Circular B;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 124%;\n  letter-spacing: 0%;\n  color: #151B26;\n}\n\n.path {\n  font-family: Euclid Circular B;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 114%;\n  letter-spacing: 0%;\n  color: #7A808B;\n}\n\n.highlight {\n  background-color: #FED45A;\n  color: #151B26;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `DirectoryObject_item__ppRg1`,
	"name": `DirectoryObject_name__aMAMd`,
	"path": `DirectoryObject_path__MQkl0`,
	"content": `DirectoryObject_content__noSOB`,
	"highlight": `DirectoryObject_highlight__8f7VP`
};
export default ___CSS_LOADER_EXPORT___;
